"use client";

import { Container } from "@/components/layout/container";
import { FlightSerializers } from "@/feature/flight/search/lib/search";
import { Plane } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { MouseEvent, useState, useTransition } from "react";

const popular_destinations = [
  {
    id: 1,
    order_number: 1,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Dubai International Airport",
    to_airport_code: "DXB",
    to_airport_country: "UNITED ARAB EMIRATES",
    to_airport_city: "Dubai",
  },
  {
    id: 2,
    order_number: 2,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Suvarnabhumi Airport",
    to_airport_code: "BKK",
    to_airport_country: "THAILAND",
    to_airport_city: "Bangkok",
  },
  {
    id: 3,
    order_number: 3,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Kuala Lumpur International Airport",
    to_airport_code: "KUL",
    to_airport_country: "MALAYSIA",
    to_airport_city: "Kuala Lumpur",
  },
  {
    id: 4,
    order_number: 4,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Singapore Changi Airport",
    to_airport_code: "SIN",
    to_airport_country: "SINGAPORE",
    to_airport_city: "Singapore",
  },
  {
    id: 5,
    order_number: 5,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Hamad International Airport",
    to_airport_code: "DOH",
    to_airport_country: "QATAR",
    to_airport_city: "Doha",
  },
  {
    id: 6,
    order_number: 6,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "King Abdulaziz International Airport",
    to_airport_code: "JED",
    to_airport_country: "SAUDI ARABIA",
    to_airport_city: "Jeddah",
  },
  {
    id: 7,
    order_number: 7,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "London Heathrow Airport",
    to_airport_code: "LHR",
    to_airport_country: "UNITED KINGDOM",
    to_airport_city: "London",
  },
  {
    id: 8,
    order_number: 8,
    from_airport_country: "UNITED STATES",
    from_airport_city: "New York",
    from_airport_name: "John F. Kennedy International Airport",
    from_airport_code: "JFK",
    to_airport_name: "London Heathrow Airport",
    to_airport_code: "LHR",
    to_airport_country: "UNITED KINGDOM",
    to_airport_city: "London",
  },
  {
    id: 9,
    order_number: 9,
    from_airport_country: "UNITED KINGDOM",
    from_airport_city: "London",
    from_airport_name: "London Heathrow Airport",
    from_airport_code: "LHR",
    to_airport_name: "Dubai International Airport",
    to_airport_code: "DXB",
    to_airport_country: "UNITED ARAB EMIRATES",
    to_airport_city: "Dubai",
  },
  {
    id: 10,
    order_number: 10,
    from_airport_country: "SINGAPORE",
    from_airport_city: "Singapore",
    from_airport_name: "Singapore Changi Airport",
    from_airport_code: "SIN",
    to_airport_name: "Sydney Kingsford Smith Airport",
    to_airport_code: "SYD",
    to_airport_country: "AUSTRALIA",
    to_airport_city: "Sydney",
  },
  {
    id: 11,
    order_number: 11,
    from_airport_country: "UNITED ARAB EMIRATES",
    from_airport_city: "Dubai",
    from_airport_name: "Dubai International Airport",
    from_airport_code: "DXB",
    to_airport_name: "John F. Kennedy International Airport",
    to_airport_code: "JFK",
    to_airport_country: "UNITED STATES",
    to_airport_city: "New York",
  },
  {
    id: 12,
    order_number: 12,
    from_airport_country: "THAILAND",
    from_airport_city: "Bangkok",
    from_airport_name: "Suvarnabhumi Airport",
    from_airport_code: "BKK",
    to_airport_name: "Narita International Airport",
    to_airport_code: "NRT",
    to_airport_country: "JAPAN",
    to_airport_city: "Tokyo",
  },
  {
    id: 13,
    order_number: 13,
    from_airport_country: "FRANCE",
    from_airport_city: "Paris",
    from_airport_name: "Charles de Gaulle Airport",
    from_airport_code: "CDG",
    to_airport_name: "Istanbul Airport",
    to_airport_code: "IST",
    to_airport_country: "TURKEY",
    to_airport_city: "Istanbul",
  },
  {
    id: 14,
    order_number: 14,
    from_airport_country: "CANADA",
    from_airport_city: "Toronto",
    from_airport_name: "Toronto Pearson International Airport",
    from_airport_code: "YYZ",
    to_airport_name: "London Heathrow Airport",
    to_airport_code: "LHR",
    to_airport_country: "UNITED KINGDOM",
    to_airport_city: "London",
  },
  {
    id: 15,
    order_number: 15,
    from_airport_country: "INDIA",
    from_airport_city: "Mumbai",
    from_airport_name: "Chhatrapati Shivaji Maharaj International Airport",
    from_airport_code: "BOM",
    to_airport_name: "Dubai International Airport",
    to_airport_code: "DXB",
    to_airport_country: "UNITED ARAB EMIRATES",
    to_airport_city: "Dubai",
  },
  {
    id: 16,
    order_number: 16,
    from_airport_country: "INDIA",
    from_airport_city: "Delhi",
    from_airport_name: "Indira Gandhi International Airport",
    from_airport_code: "DEL",
    to_airport_name: "Suvarnabhumi Airport",
    to_airport_code: "BKK",
    to_airport_country: "THAILAND",
    to_airport_city: "Bangkok",
  },
  {
    id: 17,
    order_number: 17,
    from_airport_country: "BANGLADESH",
    from_airport_city: "Dhaka",
    from_airport_name: "Hazrat Shahjalal International Airport",
    from_airport_code: "DAC",
    to_airport_name: "Velana International Airport",
    to_airport_code: "MLE",
    to_airport_country: "MALDIVES",
    to_airport_city: "Male",
  },
  {
    id: 18,
    order_number: 18,
    from_airport_country: "SINGAPORE",
    from_airport_city: "Singapore",
    from_airport_name: "Singapore Changi Airport",
    from_airport_code: "SIN",
    to_airport_name: "Ngurah Rai International Airport",
    to_airport_code: "DPS",
    to_airport_country: "INDONESIA",
    to_airport_city: "Bali",
  },
  {
    id: 19,
    order_number: 19,
    from_airport_country: "ITALY",
    from_airport_city: "Rome",
    from_airport_name: "Leonardo da Vinci Fiumicino Airport",
    from_airport_code: "FCO",
    to_airport_name: "Amsterdam Airport Schiphol",
    to_airport_code: "AMS",
    to_airport_country: "NETHERLANDS",
    to_airport_city: "Amsterdam",
  },
  {
    id: 20,
    order_number: 20,
    from_airport_country: "EGYPT",
    from_airport_city: "Cairo",
    from_airport_name: "Cairo International Airport",
    from_airport_code: "CAI",
    to_airport_name: "King Abdulaziz International Airport",
    to_airport_code: "JED",
    to_airport_country: "SAUDI ARABIA",
    to_airport_city: "Jeddah",
  },
];

function getDefaultDepartureDate() {
  const now = new Date();
  const departure = new Date(now);

  if (now.getHours() >= 18) {
    departure.setDate(departure.getDate() + 1);
  }

  const year = departure.getFullYear();
  const month = String(departure.getMonth() + 1).padStart(2, "0");
  const day = String(departure.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const PopularDestination = () => {
  const router = useRouter();
  const [activeCardId, setActiveCardId] = useState<number | null>(null);
  const [isPending, startTransition] = useTransition();

  const getFlightHref = (
    destination: (typeof popular_destinations)[number],
  ) => {
    const departDate = getDefaultDepartureDate();
    const route = FlightSerializers.flights([
      {
        from: {
          iata_code: destination.from_airport_code,
          name: destination.from_airport_name,
          city_name: destination.from_airport_city,
          country: destination.from_airport_country,
        },
        to: {
          iata_code: destination.to_airport_code,
          name: destination.to_airport_name,
          city_name: destination.to_airport_city,
          country: destination.to_airport_country,
        },
        departDate,
      },
    ]);

    const searchParams = new URLSearchParams({ trip: "oneway", route });
    return `/flights?${searchParams.toString()}`;
  };

  const handleCardNavigation = (
    event: MouseEvent<HTMLAnchorElement>,
    destination: (typeof popular_destinations)[number],
    href: string,
  ) => {
    event.preventDefault();

    if (isPending) {
      return;
    }

    setActiveCardId(destination.id);
    startTransition(() => {
      router.push(href);
    });
  };

  return (
    <Container className="relative z-10 pt-10 md:pt-24">
      <div className="pointer-events-none absolute left-0 top-[8.5rem] hidden h-px w-44 bg-linear-to-r from-transparent via-primary/30 to-transparent md:block" />

      <div className="mb-8 flex flex-col gap-5 md:mb-10 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <h2 className="mt-3 text-3xl font-extrabold tracking-tight text-foreground md:text-4xl">
            Popular Global Routes
          </h2>
          <p className="mt-2 max-w-2xl text-muted-foreground md:text-lg">
            Handpicked international flight routes designed for fast fare
            discovery across major travel hubs.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2 text-sm sm:flex">
          <div className="border-l-2 border-primary bg-secondary/70 px-3 py-2">
            <span className="block text-lg font-extrabold leading-none text-foreground">
              20+
            </span>
            <span className="text-xs font-medium text-muted-foreground">
              Live routes
            </span>
          </div>
          <div className="border-l-2 border-chart-3 bg-[#fff7e8] px-3 py-2 dark:bg-chart-3/10">
            <span className="block text-lg font-extrabold leading-none text-foreground">
              1 tap
            </span>
            <span className="text-xs font-medium text-muted-foreground">
              Fare search
            </span>
          </div>
        </div>
      </div>

      <div className="grid gap-x-10 gap-y-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {popular_destinations.map((destination) => {
          const href = getFlightHref(destination);
          const isCardLoading = isPending && activeCardId === destination.id;

          return (
            <Link
              key={destination.id}
              href={href}
              onClick={(event) =>
                handleCardNavigation(event, destination, href)
              }
              aria-disabled={isPending}
              tabIndex={isPending ? -1 : undefined}
              className={`group relative flex items-center justify-between border-b border-border/60 py-5 transition-all duration-300 ${
                isPending
                  ? "cursor-not-allowed opacity-70"
                  : "cursor-pointer hover:border-primary/50"
              }`}
            >
              {isCardLoading && (
                <div className="absolute inset-0 z-30 flex items-center justify-center bg-background/60 backdrop-blur-[1px]">
                  <div className="h-5 w-5 animate-spin rounded-full border-2 border-primary/20 border-t-primary" />
                </div>
              )}

              <div className="flex items-center gap-4">
                <span className="w-5 text-[10px] font-bold tabular-nums text-muted-foreground/50 transition-colors group-hover:text-primary/60">
                  {String(destination.order_number).padStart(2, "0")}
                </span>
                <div className="flex items-center gap-2">
                  <span className="text-xl font-black tracking-tight text-foreground">
                    {destination.from_airport_code}
                  </span>
                  <div className="h-px w-4 bg-border transition-all duration-300 group-hover:w-8 group-hover:bg-primary/50" />
                  <span className="text-xl font-black tracking-tight text-foreground">
                    {destination.to_airport_code}
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-end text-right">
                <span className="text-[10px] font-bold tracking-widest text-muted-foreground uppercase transition-colors group-hover:text-foreground">
                  {destination.to_airport_city}
                </span>
                <span className="text-[8px] font-medium text-muted-foreground/60 uppercase tracking-tighter">
                  {destination.to_airport_country}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </Container>
  );

};
